import { Nillable } from '@web/utils';

export class PublicBrandCollectionFilter {
  public constructor(public readonly name: Nillable<string>) {}
}
